export const authShellCss = `
  .auth-shell {
    position: relative;
    min-height: 100svh;
    min-height: 100dvh;
    width: 100%;
    overflow: hidden;
    isolation: isolate;
    background: var(--fintheon-bg, #050402);
    color: var(--fintheon-text, #f0ead6);
    --auth-ink: #f0ead6;
    --auth-globe-opacity: 0.94;
  }
  @media (pointer: fine) {
    .auth-shell { cursor: none; }
    .auth-shell button { cursor: pointer; }
    .auth-shell input { cursor: text; }
  }
  .auth-shell__wash,
  .auth-shell__grain {
    position: absolute;
    inset: 0;
    z-index: 0;
    pointer-events: none;
  }
  .auth-shell__wash {
    background:
      radial-gradient(circle at 68% 29%, color-mix(in srgb, var(--fintheon-primary, var(--fintheon-accent)) 10%, transparent), transparent 28%),
      linear-gradient(90deg, rgba(5, 4, 2, 0.92) 0%, rgba(5, 4, 2, 0.64) 34%, rgba(5, 4, 2, 0.17) 66%, rgba(5, 4, 2, 0.78) 100%),
      linear-gradient(0deg, rgba(5, 4, 2, 0.9) 0%, transparent 28%, transparent 68%, rgba(5, 4, 2, 0.68) 100%);
  }
  .auth-shell .auth-shell__globe {
    z-index: 1;
  }
  .auth-shell__grain {
    opacity: 0.2;
    mix-blend-mode: screen;
    background: repeating-linear-gradient(0deg, rgba(255,255,255,0.035) 0 1px, transparent 1px 3px);
  }
  .auth-shell__brand {
    position: relative;
    display: inline-flex;
    justify-self: center;
    align-items: center;
    margin: 0 0 0.08rem;
    font-family: "Doto", "Readable Digits", var(--font-heading), ui-monospace, monospace;
    font-size: clamp(1.08rem, 1.6vw, 1.28rem);
    font-weight: 760;
    line-height: 1;
    letter-spacing: 0.24em;
    text-transform: uppercase;
    font-variant-numeric: tabular-nums;
    text-rendering: geometricPrecision;
  }
  .auth-shell__brand-lockup {
    gap: 0.5rem;
  }
  .auth-shell__brand-icon {
    width: 1.42rem;
    height: 1.42rem;
    opacity: 0.96;
    filter: drop-shadow(0 0 7px rgba(240, 234, 214, 0.12));
  }
  .auth-shell__brand-title {
    color: inherit;
  }

  .auth-shell__content {
    position: relative;
    z-index: 2;
    display: grid;
    grid-template-rows: minmax(0, 1fr) auto;
    box-sizing: border-box;
    min-height: 100svh;
    min-height: 100dvh;
    padding: clamp(5.4rem, 10vh, 7.8rem) clamp(1.5rem, 2.8vw, 2.35rem) max(1.35rem, calc(1.35rem + env(safe-area-inset-bottom)));
  }
  .auth-shell__copy {
    align-self: center;
    width: min(30rem, 100%);
    transform: translateY(-5vh);
  }
  .auth-shell__copy h1 {
    margin: 0;
    color: color-mix(in srgb, var(--auth-ink) 97%, transparent);
    font-family: "Iowan Old Style", Georgia, serif;
    font-size: clamp(2.32rem, 4.1vw, 4.2rem);
    font-weight: 500;
    letter-spacing: 0;
    line-height: 0.96;
    text-wrap: balance;
    text-shadow: 0 1px 22px rgba(0, 0, 0, 0.55);
  }
  .auth-shell__points {
    display: grid;
    gap: 0.58rem;
    margin-top: clamp(1.45rem, 3.2vh, 2.1rem);
  }
  .auth-shell__point {
    display: flex;
    align-items: center;
    gap: 0.58rem;
    min-height: 2.2rem;
    color: color-mix(in srgb, var(--auth-ink) 72%, transparent);
    font-size: 0.95rem;
    line-height: 1.2;
  }
  .auth-shell__point-icon {
    display: inline-flex;
    width: 2.1rem;
    height: 2.1rem;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    border: 1px solid color-mix(in srgb, var(--auth-ink) 11%, transparent);
    border-radius: 0.42rem;
    color: color-mix(in srgb, var(--auth-ink) 90%, var(--fintheon-primary, var(--fintheon-accent)));
    background: color-mix(in srgb, var(--auth-ink) 9%, transparent);
    backdrop-filter: blur(12px) saturate(1.2);
    -webkit-backdrop-filter: blur(12px) saturate(1.2);
  }
  .auth-shell__actions {
    display: grid;
    grid-row: 2;
    gap: 0.8rem;
    justify-self: center;
    width: min(30rem, 100%);
  }
  .auth-shell__actions p {
    margin: 0.2rem 0 0;
    color: color-mix(in srgb, var(--auth-ink) 45%, transparent);
    font-size: 0.78rem;
    line-height: 1.45;
    text-align: center;
  }

  @media (max-width: 720px) {
    .auth-shell {
      --auth-globe-opacity: 0.92;
    }
    .auth-shell__wash {
      background:
        linear-gradient(90deg, rgba(5, 4, 2, 0.9), rgba(5, 4, 2, 0.48) 54%, rgba(5, 4, 2, 0.76)),
        linear-gradient(0deg, rgba(5, 4, 2, 0.95), transparent 42%, rgba(5, 4, 2, 0.62));
    }
    .auth-shell__content {
      padding-top: 6.5rem;
      padding-bottom: max(1.15rem, calc(1.15rem + env(safe-area-inset-bottom)));
    }
    .auth-shell__copy { transform: translateY(-2vh); }
    .auth-shell__copy h1 {
      font-size: clamp(2.05rem, 11vw, 3.25rem);
      max-width: 9.5em;
    }
    .auth-shell__point { font-size: 0.9rem; }
  }

  @media (max-width: 720px) and (max-height: 760px) {
    .auth-shell__copy { transform: translateY(-0.75rem); }
    .auth-shell__copy h1 { font-size: 2.25rem; }
    .auth-shell__points { gap: 0.4rem; margin-top: 1rem; }
    .auth-shell__point { min-height: 1.95rem; }
    .auth-shell__actions { gap: 0.58rem; }
  }
`;
